import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "accented-container" }
const _hoisted_2 = { class: "basic-alert d-flex justify-content-start align-items-center" }
const _hoisted_3 = { class: "px-2" }
const _hoisted_4 = {
  class: "font-weight-bold flex-grow-1",
  "data-testid": "message"
}

import { computed } from 'vue';
import useStickyAlerts from '@/modules/alerts/composables/useStickyAlerts';
import {
  BasicStickyAlertPropsSchema,
  BASIC_STICKY_ALERT_TYPE,
  BasicStickyAlertType,
} from '@/modules/alerts/models/basic-sticky-alert-props';
import { STICKY_ALERT_TYPE } from '@/modules/alerts/models/sticky-alert-type';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

interface TypeBasedProperties {
  foregroundColorClass: string;
  backgroundColorClass: string;
  icon: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WCBasicStickyAlert',
  props: {
    type: {},
    message: {},
    timeoutMs: {},
    id: {}
  },
  setup(__props: any) {

const { findAlert, answerAlert } = useStickyAlerts();

const props = __props;

const alert = findAlert(STICKY_ALERT_TYPE.BASIC, props.id);

const propertyMap: Record<BasicStickyAlertType, TypeBasedProperties> = {
  [BASIC_STICKY_ALERT_TYPE.SUCCESS]: {
    foregroundColorClass: 'text-success',
    backgroundColorClass: 'bg-success',
    icon: 'circle-check',
  },
  [BASIC_STICKY_ALERT_TYPE.WARNING]: {
    foregroundColorClass: 'text-warning',
    backgroundColorClass: 'bg-warning',
    icon: 'triangle-exclamation',
  },
  [BASIC_STICKY_ALERT_TYPE.ERROR]: {
    foregroundColorClass: 'text-danger',
    backgroundColorClass: 'bg-danger',
    icon: 'circle-exclamation',
  },
};

const foregroundColorClass = computed(() => propertyMap[props.type].foregroundColorClass);
const backgroundColorClass = computed(() => propertyMap[props.type].backgroundColorClass);
const icon = computed(() => propertyMap[props.type].icon);

const close = () => {
  answerAlert(alert, { result: 'DISMISS' });
};

if (!props.timeoutMs) {
  console.debug('timeoutMs is 0 (or falsy), not setting timeout.');
} else {
  console.debug(`Creating dismiss timeout for ${props.timeoutMs}ms from now.`);
  setTimeout(() => {
    const delayedAlert = findAlert(STICKY_ALERT_TYPE.BASIC, props.id);
    if (delayedAlert === null) {
      console.debug('Failed to find alert while timing out, it must have already been closed.');
      return;
    }
    answerAlert(alert, { result: 'TIME_OUT' });
  }, props.timeoutMs);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["accent", backgroundColorClass.value]),
      "data-testid": "accent"
    }, null, 2),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(FontAwesomeIcon), {
          icon: icon.value,
          size: "lg",
          class: _normalizeClass(foregroundColorClass.value),
          "data-testid": "icon"
        }, null, 8, ["icon", "class"])
      ]),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _createElementVNode("span", _hoisted_4, _toDisplayString(props.message), 1),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createElementVNode("div", {
        class: "px-2 cursor-pointer",
        onClick: close,
        "data-testid": "closeButton"
      }, [
        _createVNode(_unref(FontAwesomeIcon), {
          icon: "xmark",
          size: "lg"
        })
      ])
    ])
  ]))
}
}

})